// TimelinePath — the timeline path landmark. Wraps the Path landmark
// (TubeGeometry along TIMELINE_PATH) with scene-aware active-milestone
// highlighting. The path is the "path" scene's landmark.

import { Path } from './landmarks/Path';
import { TIMELINE_MILESTONES } from './planetSections';

export interface TimelinePathProps {
  /** Active scene index (used to find the active milestone). */
  activeSceneIndex: number;
  /** Whether the path scene is active. */
  isActive?: boolean;
}

/** Map active scene index to the active milestone index. */
function milestoneForScene(sceneIndex: number): number {
  // The path scene is index 5. The 6 milestones are distributed across
  // 6 positions; we map progress within the path scene to a milestone
  // index. For now, when the path scene is active we pick a milestone
  // based on the blend-in progress.
  if (sceneIndex !== 5) return -1;
  return 0; // The path's own active milestone is decided at the HUD
  // level. The path landmark always highlights the first milestone
  // when its scene is active; finer control is the next phase.
}

export function TimelinePath({ activeSceneIndex, isActive }: TimelinePathProps) {
  return (
    <Path
      isActive={isActive ?? false}
      activeMilestoneIndex={milestoneForScene(activeSceneIndex)}
    />
  );
}

export default TimelinePath;
